<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-sell')) {
      <ion-item button="true" (click)="unparkCart()">
        <ion-label><fa-icon [icon]="['fal', 'folder-open']" size="lg" [fixedWidth]="true"></fa-icon>Open</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-parked-carts-print-job-sheet') && printer_paper_sizes && printer_paper_sizes.length > 0) {
      @if (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" id="print_job_sheet" detail="true">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print job sheet</ion-label>
        </ion-item>
        <ion-popover trigger="print_job_sheet" [dismissOnSelect]="true" side="start">
          <ng-template>
            <ion-content>
              <ion-list lines="full">
                @if (printer_paper_sizes.includes('a4')) {
                  <ion-item button="true" (click)="printParkedCartJobSheet('a4')">
                    <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                  </ion-item>
                }
                @if (printer_paper_sizes.includes('thermal')) {
                  <ion-item button="true" (click)="printParkedCartJobSheet('thermal')">
                    <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                  </ion-item>
                }
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      }
      @if (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" (click)="printParkedCartJobSheet('a4')">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print job sheet</ion-label>
        </ion-item>
      }
      @if (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" (click)="printParkedCartJobSheet('thermal')">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print job sheet</ion-label>
        </ion-item>
      }
    }

    @if (permissionService.isPermitted('pos-sell') && permissionService.isPermitted('pos-parked-carts-duplicate-parked-cart')) {
      <ion-item button="true" (click)="duplicateCart()">
        <ion-label><fa-icon [icon]="['fal', 'copy']" size="lg" [fixedWidth]="true"></fa-icon>Duplicate</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-parked-carts-edit-parked-cart')) {
      <ion-item button="true" (click)="presentParkedCartEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-parked-carts-delete-parked-cart')) {
      <ion-item button="true" (click)="deleteParkedCart()">
        <ion-label><fa-icon [icon]="['fal', 'trash-alt']" size="lg" [fixedWidth]="true"></fa-icon>Delete</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
